"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _styles = require("@material-ui/core/styles");

var _jquery = _interopRequireDefault(require("jquery"));

var _eonasdanBootstrapDatetimepicker = _interopRequireDefault(require("eonasdan-bootstrap-datetimepicker"));

var _bootstrapDatetimepicker = _interopRequireDefault(require("../../styles/bootstrap/bootstrap-datetimepicker.css"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var theme = (0, _styles.createMuiTheme)({
  // For Underline Color After Click
  palette: {
    primary: {
      main: "rgba(255, 255, 255, 1)"
    }
  },
  // For Underline Hover Color
  overrides: {
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: '1px solid #ffffff!important'
        },
        '&:after': {
          borderBottom: '2px solid #0275d8!important'
        }
      },
      root: {
        // Name of the rule
        color: 'white' // Some CSS

      }
    }
  }
});

var InputField = /*#__PURE__*/function (_React$Component) {
  _inherits(InputField, _React$Component);

  function InputField() {
    var _this;

    _classCallCheck(this, InputField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputField).call(this));
    _this.state = {};
    return _this;
  }

  _createClass(InputField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if ((0, _jquery["default"])(this._input).hasClass('datepicker')) {
        (0, _jquery["default"])(this._input).each(function (index, element) {
          (0, _jquery["default"])(element).datetimepicker({
            useCurrent: false,
            format: 'DD/MM/YYYY'
          }).on('dp.change', function (e) {
            var value = e.date.format ? e.date.format('DD/MM/YYYY') : null;
            setTimeout(function () {
              (0, _jquery["default"])(element).data('DateTimePicker').hide();

              _this2.props.handler.handleInputChange(_this2.props.name, value);
            }, 50);
          });
        });
      }
    }
    /**
     * Get class name
     *
     * @returns {string}
     */

  }, {
    key: "getClassName",
    value: function getClassName() {
      var classNames = ['input-group'];

      if (this.props.fullWidth) {
        classNames.push('fulled');
      }

      return classNames.join(' ');
    }
  }, {
    key: "_getInputClassName",
    value: function _getInputClassName() {
      var classNames = [];
      var type = this.props.type;

      switch (type) {
        case 'date':
          classNames.push('datepicker');
          break;
      }

      return classNames.join(' ');
    }
    /**
     * Handle input change
     *
     * @param e
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(e) {
      if (this.props.handler) {
        this.props.handler.handleInputChange(e);
      }

      this.props.onChange(e);
    }
  }, {
    key: "getValidationError",
    value: function getValidationError() {
      var _this3 = this;

      var messages = [];

      if (!this.props.handler) {
        return null;
      }

      this.props.handler.getErrors().filter(function (x) {
        return x.field == _this3.props.name;
      }).forEach(function (error) {
        return messages.push(error.message);
      });

      if (messages.length == 0) {
        return null;
      }

      return _react["default"].createElement("div", {
        className: "validation-message",
        key: this.props.name + '-error'
      }, messages.join("<br/>"));
    }
  }, {
    key: "_getType",
    value: function _getType() {
      var type = this.props.type;

      if (!type) {
        type = 'text';
      }

      if (type == 'date') {
        type = 'text';
      }

      return type;
    }
  }, {
    key: "_getNote",
    value: function _getNote() {
      if (!this.props.note) return null;
      return _react["default"].createElement("em", {
        style: {
          position: 'absolute',
          right: 0,
          bottom: -20
        }
      }, this.props.note);
    }
    /**
     * Render input
     *
     * @returns {XML}
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var inputProps = _lodash["default"].get(this.props.materialProps, 'inputProps', {});

      var className = _lodash["default"].get(inputProps, 'className', '');

      className += ' ' + this._getInputClassName();
      inputProps.className = className;

      inputProps.ref = function (ref) {
        return _this4._input = ref;
      };

      var materialProps = _objectSpread({}, this.props.materialProps, {
        inputProps: inputProps
      });

      var containerClassName = this.getClassName();

      var type = this._getType();

      var validationError = this.getValidationError();
      return _react["default"].createElement("div", {
        className: containerClassName
      }, _react["default"].createElement(_styles.MuiThemeProvider, {
        theme: theme
      }, _react["default"].createElement(_TextField["default"], _extends({
        ref: "actualInput",
        autoComplete: this.props.autoComplete,
        label: this.props.label,
        type: type,
        name: this.props.name,
        inputProps: this.props.inputProps,
        value: this.props.value,
        multiline: type == 'textarea',
        onChange: this.handleInputChange.bind(this)
      }, materialProps)), this._getNote()), validationError);
    }
  }]);

  return InputField;
}(_react["default"].Component);

exports["default"] = InputField;
InputField.defaultProps = {
  onChange: function onChange(e) {}
};